import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiError } from "@/lib/apiClient";
import { Mail, ArrowLeft, CheckCircle2 } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <main className="bg-onyx min-h-screen pt-16 flex items-center grain" data-testid="forgot-password-page">
      <div className="max-w-md mx-auto w-full px-5 py-20">
        <div className="text-center mb-10">
          <Mail className="text-gold mx-auto mb-4" size={40} strokeWidth={1.5} />
          <h1 className="font-serif text-4xl text-bone">Forgot Password</h1>
          <p className="text-bone/50 mt-2">Enter your email and we'll send you a reset link.</p>
        </div>
        {sent ? (
          <div className="bg-surface border border-white/10 p-8 text-center" data-testid="forgot-password-success">
            <CheckCircle2 className="text-gold mx-auto mb-4" size={36} />
            <p className="text-bone/80">If an account exists for that email, a password reset link has been sent. Please check your inbox.</p>
            <Link to="/login" className="inline-flex items-center gap-2 text-gold hover:text-gold2 mt-6 text-sm" data-testid="back-to-login-link">
              <ArrowLeft size={16} /> Back to sign in
            </Link>
          </div>
        ) : (
          <form onSubmit={submit} className="bg-surface border border-white/10 p-8 space-y-5" data-testid="forgot-password-form">
            <div>
              <label className="text-xs uppercase tracking-widest text-bone/60 mb-2 block">Email</label>
              <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="forgot-email"
                className="w-full bg-black/50 border border-white/10 px-4 py-3 text-bone focus:outline-none focus:border-gold/50" />
            </div>
            {error && <p className="text-red-400 text-sm" data-testid="forgot-error">{error}</p>}
            <button type="submit" disabled={loading} data-testid="forgot-submit"
              className="w-full bg-gold text-black py-3 font-medium hover:bg-gold2 transition-colors disabled:opacity-60">
              {loading ? "Sending..." : "Send Reset Link"}
            </button>
            <Link to="/login" className="flex items-center justify-center gap-2 text-bone/50 hover:text-gold text-sm mt-2" data-testid="back-to-login-link">
              <ArrowLeft size={16} /> Back to sign in
            </Link>
          </form>
        )}
      </div>
    </main>
  );
}
